import React, { useState } from 'react';
import { Modal } from './Modal';
type ModalType = 'terms' | 'privacy' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <div className="mt-6 border-t border-[#E8CFCF]/30 pt-6" data-id="element-283">
      <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-[#3A3A3A]/50 font-medium" data-id="element-284">
        <button onClick={() => setActiveModal('terms')} className="hover:text-[#D88C7A] transition-colors hover:underline underline-offset-4" data-id="element-285">
          Términos y condiciones
        </button>
        <span className="hidden md:inline text-[#3A3A3A]/30" data-id="element-286">•</span>
        <button onClick={() => setActiveModal('privacy')} className="hover:text-[#D88C7A] transition-colors hover:underline underline-offset-4" data-id="element-287">
          Política de privacidad
        </button>
      </div>

      <div className="mt-4 text-[#3A3A3A]/40 text-xs" data-id="element-288">
        &copy; {new Date().getFullYear()} Crianza Consciente. Todos los derechos
        reservados.
      </div>

      {/* MODALS */}

      {/* Términos y Condiciones */}
      <Modal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-289">
        <div className="space-y-4" data-id="element-290">
          <p data-id="element-291">
            Bienvenido a nuestra guía de Crianza con Inteligencia Emocional. Al
            adquirir y utilizar nuestros productos digitales, aceptas los
            siguientes términos:
          </p>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-292">
            1. Uso Personal
          </h3>
          <p data-id="element-293">
            Todo el contenido incluido en esta guía y sus bonos es para uso
            personal y exclusivo del comprador. Está prohibida su distribución,
            reproducción, venta o compartición con terceros sin autorización
            expresa.
          </p>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-294">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-295">
            Todos los derechos de autor, marcas y propiedad intelectual del
            contenido pertenecen a Crianza Consciente. La compra no transfiere
            los derechos de propiedad intelectual al usuario.
          </p>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-296">
            3. Naturaleza del Producto
          </h3>
          <p data-id="element-297">
            Este es un producto 100% digital. No se enviará ningún material
            físico. El acceso al contenido se entregará vía correo electrónico
            inmediatamente después de confirmada la compra.
          </p>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-298">
            4. Exención de Responsabilidad
          </h3>
          <p data-id="element-299">
            El contenido de esta guía tiene fines educativos e informativos. No
            sustituye el consejo médico, psicológico o terapéutico profesional.
            Si tú o tus hijos requieren atención especializada, recomendamos
            consultar a un profesional de la salud.
          </p>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-300">
            5. Política de Reembolso
          </h3>
          <p data-id="element-301">
            Debido a la naturaleza digital del producto, ofrecemos una garantía
            de satisfacción de 7 días. Si no estás satisfecha con el contenido,
            contáctanos para evaluar tu caso.
          </p>
        </div>
      </Modal>

      {/* Política de Privacidad */}
      <Modal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-302">
        <div className="space-y-4" data-id="element-303">
          <p data-id="element-304">
            En Crianza Consciente, nos tomamos muy en serio la privacidad de tus
            datos. Esta política describe cómo recopilamos y utilizamos tu
            información.
          </p>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-305">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-306">
            Recopilamos información necesaria para procesar tu pedido, como tu
            nombre, dirección de correo electrónico y detalles de pago. No
            almacenamos información sensible de tarjetas de crédito en nuestros
            servidores; utilizamos procesadores de pago seguros.
          </p>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-307">
            2. Uso de la Información
          </h3>
          <p data-id="element-308">Utilizamos tu información para:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-309">
            <li data-id="element-310">Entregar el producto digital a tu correo.</li>
            <li data-id="element-311">Procesar el pago de forma segura.</li>
            <li data-id="element-312">Enviarte actualizaciones importantes sobre el producto.</li>
            <li data-id="element-313">Responder a tus consultas de soporte.</li>
          </ul>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-314">
            3. Protección de Datos
          </h3>
          <p data-id="element-315">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tus datos personales contra el acceso no autorizado, la
            pérdida o la alteración.
          </p>

          <h3 className="text-lg font-bold text-stone-800 mt-4" data-id="element-316">4. Cookies</h3>
          <p data-id="element-317">
            Utilizamos cookies esenciales para el funcionamiento del carrito de
            compras y el proceso de pago. No utilizamos cookies de rastreo
            invasivas.
          </p>
        </div>
      </Modal>
    </div>;
}